import React from "react";
import { Grid, GridProps } from "semantic-ui-react";
import styled from "styled-components";

type DoubleBreakpointGridProps = GridProps;

const StyledGrid = styled(Grid)({
  "&&&": {
    // doubling
    "@media only screen and (max-width: 991px) and (min-width: 501px)": {
      ".column": {
        width: "50%!important",
      },
    },
    // stackable
    "@media only screen and (max-width: 500px)": {
      ".column": {
        width: "100%!important",
      },
    },
  },
});

const DoubleBreakpointGrid: React.FC<DoubleBreakpointGridProps> = ({
  children,
  ...props
}) => {
  // This Grid by default is stackable and doubling
  // We are overriding default semantic values here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { stackable, doubling, ...restProps } = props;

  return <StyledGrid {...restProps}>{children}</StyledGrid>;
};
export default DoubleBreakpointGrid;
